import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet} from '@angular/router';
import { filter } from 'rxjs';
import { OrganizationService }  from '../../../core/services/organization.service';
import { TopTabItem, TopTabViewComponent } from '../../../shared/components/top-tab-view/top-tab-view';

@Component({
  selector: 'app-exam-panel',
  standalone: true,
  imports: [
    RouterOutlet,
    TopTabViewComponent
  ],
  templateUrl: './exam-panel.html'
})
export class ExamPanelComponent implements OnInit {
  activeTab = 'dashboard';

  operationTabs: TopTabItem[] = [
    { key: 'dashboard', title: 'Dashboard' },
    { key: 'organization', title: 'Organization' },
    { key: 'exam-slot', title: 'Exam Slot' }
  ];

 constructor(
  private router: Router,
  private organizationService: OrganizationService
) {}

 ngOnInit(): void {

  this.organizationService
    .getOrganizations()
    .subscribe({
      next: (organizations) => {

      },
      error: (error) => {
        console.error(
          'Failed to load organizations:',
          error
        );
      }
    });

    const navigationType =
      performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;

    if (navigationType?.type === 'reload') {

      this.router.navigate(
        ['/exam/exam-panel/scan-qr'],
        { replaceUrl: true }
      );
    }
}
}
